import { type SavedConfigurationDTO } from "../dtos";
import { submitAsForm } from "../../../api/ApiHelper";
import { SHARE_LINEAR_CONFIGURATIONS_CODE_SEPARATOR } from "../../../utils/constants";
import { resolveUrl } from "../../../utils/url/urlResolver";

// Since this is submitAsForm, let's use regular resolve
const apiUrl = resolveUrl("/store-finder");

export function apiShareConfigurationViaSalesPartnerFinder(items: Omit<SavedConfigurationDTO, "baseExternalUrl">[]) {
  const requestObject = items.map((item) => item.code).join(SHARE_LINEAR_CONFIGURATIONS_CODE_SEPARATOR);
  const data = {
    configurations: requestObject,
  };
  submitAsForm(data, apiUrl);
}
